// extracted by mini-css-extract-plugin
export default {"menubox":"MenuInternal_menubox__JQdxU","horizmenu":"MenuInternal_horizmenu__o-uq-"};